import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { ListingEnquiryForm, TListingEnquiryFormCodec } from "./formEditable/ListingEnquiryForm";
import { HomesAdminPagePartial, THomesAdminPagePartialCodec } from "./statePartials/HomesAdminPagePartial";
import { JobsPartial, TJobsPartialCodec } from "./statePartials/JobsPartial";
import { PublicOffersPagePartial, TPublicOffersPagePartialCodec } from "./statePartials/PublicOffersPagePartial";
import { LegalCaseDetailsPagePartial, TLegalCaseDetailsPagePartialCodec } from "./statePartials/LegalCaseDetailsPagePartial";
import { ListingPagePartial, TListingPagePartialCodec } from "./statePartials/ListingPagePartial";
import { ListingsProfitReportPagePartial, TListingsProfitReportPagePartialCodec } from "./statePartials/ListingsProfitReportPagePartial";
import { PartyPagePartial, TPartyPagePartialCodec } from "./statePartials/PartyPagePartial";
import { ListingPerformancePagePartial, TListingPerformancePagePartialCodec } from "./statePartials/ListingPerformancePagePartial";
import { GlobalLegalPartial, TGlobalLegalPartialCodec } from "./statePartials/GlobalLegalPartial";
import { required, TRequiredCodec } from "../../shared/src/codecs/types/required";
import { createNewDefaultLens, TCodecLens } from "../../shared/src/codecs/codecLens";
import { TitleChecksPageFormIO, TTitleChecksPageFormIOCodec } from "./formIO/TitleChecksPageFormIO";
import { LegalCasesKeyDatesFormIO, TLegalCasesKeyDatesFormIOCodec } from "./formIO/LegalCasesKeyDatesFormIO";
import { TTwoFactorAuthFormCodec, TwoFactorAuthForm } from "./form/TwoFactorAuthForm";
import { AuthenticatorPageForm, TAuthenticatorPageFormCodec } from "./form/AuthenticatorForm";
import { ClientCaseForm, TClientCaseFormCodec } from "./form/ClientCaseForm";
import { LegalCaseLedgerPagePartial, TLegalCaseLedgerPagePartialCodec } from "./statePartials/LegalCaseLedgerPagePartial";
import { TriageActiveTypeVisible, TriageAssigneeActiveTypeVisible, TriageForm, TriageLeftPaneMode, TTriageActiveTypeVisibleCodec, TTriageAssigneeActiveTypeVisibleCodec, TTriageFormCodec, TTriageLeftPaneModeCodec } from "./form/TriageForm";
import { GetStaffInboxesForm, TGetStaffInboxesFormCodec, ToggleAwayStatusForm, TToggleAwayStatusFormCodec } from "./form/StaffAwayForm";
import { TInboxCountFormCodec, InboxCountForm } from "./form/InboxCountForm";
import { IntroducersForm, TIntroducersFormCodec } from "./form/IntroducerForm";
import { CaseCustomerSatisfactionForm, TCaseCustomerSatisfactionFormCodec } from "./form/CaseCustomerSatisfactionForm";
import { CaseComplianceRaisesForm, TCaseComplianceRaisesFormCodec } from "./form/CaseComplianceForm";
import { ClientCompanyPartnershipPageForm, TClientCompanyPartnershipPageFormCodec } from "./form/ClientCompanyPartnershipForm";
import { TProbateHelplineCallbackTypeFormCodec, ProbateHelplineCallbackTypeForm, TProbateHelplineCallbackTypeVisibleCodec, ProbateHelplineCallbackTypeVisible } from "./form/ProbateHelplineCallbackForm";
import { MarketingCampaignsForm, TMarketingCampaignsFormCodec } from "./form/MarketingCampaignForm";
import { QuoteRateActiveTypeVisible, QuoteRatePageForm, TQuoteRatePageFormCodec, TQuoteRateActiveTypeVisibleCodec } from "./form/QuoteRateForm";
import { TUnionCodec, union } from "../../shared/src/codecs/types/union";
import { nullCodec, TNullCodec } from "../../shared/src/codecs/types/nullCodec";
import { TUuidCodec, uuid } from "../../shared/src/codecs/types/uuid";
import { PublicQuotePage, TPublicQuotePageCodec } from "./form/PublicQuoteForm";
import { CaseAutoAssignmentPageForm, TCaseAutoAssignmentPageFormCodec } from "./form/CaseAutoAssignmentForm";
import { EmailTemplatesForm, TEmailTemplatesFormCodec } from "./form/EmailTemplatesForm";
import { LendersPageForm, TLendersPageFormCodec } from "./form/LenderForm";
import { RoadblockAssignmentPageForm, TRoadblockAssignmentPageFormCodec } from "./form/RoadblockAssignmentForm";
import { RoadblocksForm, RoadblocksForm2, TRoadblocksForm2Codec, TRoadblocksFormCodec } from "./form/RoadblockForm";
import { CaseTimelineForm, TCaseTimelineFormCodec } from "./form/CaseTimelineForm";
import { TAnyStringCodec, string } from "../../shared/src/codecs/types/string";
import { CaseContractSectionForm, TCaseContractSectionFormCodec } from "./form/CaseContractSectionForm";
import { CaseManagementCompaniesForm, TCaseManagementCompaniesFormCodec } from "./form/ManagementCompanyForm";
import { CaseTitleChecksForm, TCaseTitleChecksFormCodec } from "./form/CaseTitleChecksForm";
import { PublicPropertyReportPage, TPublicPropertyReportPageCodec } from "./form/PublicPropertyReportForm";
import { CaseChargesAndRestrictionsForm, TCaseChargesAndRestrictionsFormCodec } from "./form/CaseChargesAndRestrictionForm";
import { SessionFeatureToggleForm, TSessionFeatureToggleFormCodec } from "./form/SessionFeatureToggleForm";
import { TBooleanCodec, boolean } from "../../shared/src/codecs/types/boolean";
import { CasesPage, TCasesPageCodec } from "./form/CasesForm";
import { CreateServiceBearerTokenForm, TCreateServiceBearerTokenFormCodec } from "./form/CreateServiceBearerTokenForm";
import { CaseChaseModeForm, TCaseChaseModeFormCodec } from "./form/CasesChaseTransitionForm";
import { CreateStaffUserForm, TCreateStaffUserFormCodec } from "./form/CreateStaffUserForm";
import { ChangeStaffUserPasswordForm, TChangeStaffUserPasswordFormCodec } from "./form/ChangeStaffUserPasswordForm";
import { GetProofOfFundsDocumentsFormIO, TGetProofOfFundsDocumentsFormIOCodec } from "./formIO/GetProofOfFundsDocumentsFormIO";

export type TStateCodec = TRequiredCodec<{
    block_column_picker: TRequiredCodec<{
        opens: TUnionCodec<[TNullCodec, TAnyStringCodec]>;
    }>,
    homes_admin_page: THomesAdminPagePartialCodec,
    jobs: TJobsPartialCodec,
    overlay: TRequiredCodec<{
        roadblocks: TRoadblocksFormCodec,
        listing_roadblocks: TListingRoadblocksDashboardFormCodec,
        listing_roadblocks_week_counts: TListingRoadblocksDashboardWeekCountsFormCodec
    }>,
    public_offers_page: TPublicOffersPagePartialCodec,
    global_legal: TGlobalLegalPartialCodec,
    title_checks_page: TTitleChecksPageFormIOCodec,
    legal_cases_key_dates: TLegalCasesKeyDatesFormIOCodec,
    case_details_page: TLegalCaseDetailsPagePartialCodec,
    case_ledger_page: TLegalCaseLedgerPagePartialCodec,
    case_satisfaction_page: TCaseCustomerSatisfactionFormCodec,
    case_compliance_raises_page: TCaseComplianceRaisesFormCodec,
    listing_page: TListingPagePartialCodec,
    listings_profit_report_page: TListingsProfitReportPagePartialCodec,
    party_page: TPartyPagePartialCodec,
    listing_performance_page: TListingPerformancePagePartialCodec,
    listing_enquiry_page: TListingEnquiryFormCodec,
    buyer2FAPage: TTwoFactorAuthFormCodec,
    authenticator_page: TAuthenticatorPageFormCodec,
    client_case_page: TClientCaseFormCodec,
    triage_page: TRequiredCodec<{
        expired: TTriageFormCodec,
        unassigned: TTriageFormCodec,
        staff_inboxes: TGetStaffInboxesFormCodec,
        staff_inbox_emails: TTriageFormCodec,
        active_type_visible: TTriageActiveTypeVisibleCodec,
        left_pane_mode: TTriageLeftPaneModeCodec,
        weekly_updates_open_case_id: TUnionCodec<[TNullCodec, TAnyStringCodec]>,
    }>,
    case_inbox_page: TRequiredCodec<{
        unresolved: TTriageFormCodec,
    }>, 
    inbox_assignee_page: TRequiredCodec<{
        resolved: TTriageFormCodec,
        unresolved: TTriageFormCodec,
        confidential: TTriageFormCodec,
        untriaged: TTriageFormCodec,
        active_type_visible: TTriageAssigneeActiveTypeVisibleCodec,
        open_email_id: TUnionCodec<[TNullCodec, TAnyStringCodec]>,
        right_column_compose_override: TBooleanCodec,
    }>,
    inbox_count_form: TInboxCountFormCodec,
    introducers_block: TRequiredCodec<{
        introducer_id_open: TUnionCodec<[TNullCodec, TUuidCodec]>,
        data: TIntroducersFormCodec,
    }>,
    marketing_campaigns_block: TMarketingCampaignsFormCodec,
    client_company_partners_page: TClientCompanyPartnershipPageFormCodec,
    probate_helpline_callbacks_page: TRequiredCodec<{
        now: TProbateHelplineCallbackTypeFormCodec,
        completed: TProbateHelplineCallbackTypeFormCodec,
        active_type_visible: TProbateHelplineCallbackTypeVisibleCodec,
    }>,
    quote_rates_page: TRequiredCodec<{
        data: TQuoteRatePageFormCodec,
        active_type_visible: TQuoteRateActiveTypeVisibleCodec,
    }>,
    public_quote_page: TPublicQuotePageCodec,
    case_assignment_page_form: TCaseAutoAssignmentPageFormCodec,
    lenders_page_form: TLendersPageFormCodec,
    email_templates_form: TEmailTemplatesFormCodec,
    roadblock_assignment_page_form: TRoadblockAssignmentPageFormCodec,
    case_roadblocks_block: TRoadblocksForm2Codec,
    case_timeline_block: TCaseTimelineFormCodec,
    contracts_block: TCaseContractSectionFormCodec,
    case_management_companies: TCaseManagementCompaniesFormCodec,
    case_title_checks_block: TCaseTitleChecksFormCodec,
    public_property_report_page: TPublicPropertyReportPageCodec,
    case_charges_and_restrictions_block: TCaseChargesAndRestrictionsFormCodec,
    session_feature_toggle_form: TSessionFeatureToggleFormCodec,
    weekly_kpi_is_showing: TBooleanCodec,
    cases_page: TCasesPageCodec,
    bearer_token_page: TCreateServiceBearerTokenFormCodec,
    chase_mode_form: TCaseChaseModeFormCodec,
    create_staff_user_page: TCreateStaffUserFormCodec,
    change_staff_user_password_page: TChangeStaffUserPasswordFormCodec,
    crm_proof_of_funds_documents: TGetProofOfFundsDocumentsFormIOCodec,
}>;

import { ListingRoadblocksDashboardForm, TListingRoadblocksDashboardFormCodec, ListingRoadblocksDashboardWeekCountsForm, TListingRoadblocksDashboardWeekCountsFormCodec } from "./form/ListingRoadblockForm";

export const state: TStateCodec = required({
    block_column_picker: required({
        opens: union([nullCodec(), string()]),
    }),
    homes_admin_page: HomesAdminPagePartial,
    jobs: JobsPartial,
    overlay: required({
        roadblocks: RoadblocksForm,
        listing_roadblocks: ListingRoadblocksDashboardForm,
        listing_roadblocks_week_counts: ListingRoadblocksDashboardWeekCountsForm
    }),
    public_offers_page: PublicOffersPagePartial,
    global_legal: GlobalLegalPartial,
    title_checks_page: TitleChecksPageFormIO,
    legal_cases_key_dates: LegalCasesKeyDatesFormIO,
    case_details_page: LegalCaseDetailsPagePartial,
    case_ledger_page: LegalCaseLedgerPagePartial,
    case_satisfaction_page: CaseCustomerSatisfactionForm,
    case_compliance_raises_page: CaseComplianceRaisesForm,
    listing_page: ListingPagePartial,
    listings_profit_report_page: ListingsProfitReportPagePartial,
    party_page: PartyPagePartial,
    listing_performance_page: ListingPerformancePagePartial,
    listing_enquiry_page: ListingEnquiryForm,
    buyer2FAPage: TwoFactorAuthForm,
    authenticator_page: AuthenticatorPageForm,
    client_case_page: ClientCaseForm,
    triage_page: required({
        expired: TriageForm,
        unassigned: TriageForm,
        staff_inboxes: GetStaffInboxesForm,
        staff_inbox_emails: TriageForm,
        active_type_visible: TriageActiveTypeVisible,
        left_pane_mode: TriageLeftPaneMode,
        weekly_updates_open_case_id: union([nullCodec(), string()]),
    }),
    case_inbox_page: required({
        unresolved: TriageForm,
    }),
    inbox_assignee_page: required({
        resolved: TriageForm,
        unresolved: TriageForm,
        confidential: TriageForm,
        untriaged: TriageForm,
        active_type_visible: TriageAssigneeActiveTypeVisible,
        open_email_id: union([nullCodec(), string()]),
        right_column_compose_override: boolean(),
    }),
    inbox_count_form: InboxCountForm,
    introducers_block: required({
        introducer_id_open: union([nullCodec(), uuid()]),
        data: IntroducersForm,
    }),
    marketing_campaigns_block: MarketingCampaignsForm,
    client_company_partners_page: ClientCompanyPartnershipPageForm,
    probate_helpline_callbacks_page: required({
        now: ProbateHelplineCallbackTypeForm,
        completed: ProbateHelplineCallbackTypeForm,
        active_type_visible: ProbateHelplineCallbackTypeVisible,
    }),
    quote_rates_page: required({
        data: QuoteRatePageForm,
        active_type_visible: QuoteRateActiveTypeVisible
    }),
    public_quote_page: PublicQuotePage,
    case_assignment_page_form: CaseAutoAssignmentPageForm,
    lenders_page_form: LendersPageForm,
    email_templates_form: EmailTemplatesForm,
    roadblock_assignment_page_form: RoadblockAssignmentPageForm,
    case_roadblocks_block: RoadblocksForm2,
    case_timeline_block: CaseTimelineForm,
    contracts_block: CaseContractSectionForm,
    case_management_companies: CaseManagementCompaniesForm,
    case_title_checks_block: CaseTitleChecksForm,
    public_property_report_page: PublicPropertyReportPage,
    case_charges_and_restrictions_block: CaseChargesAndRestrictionsForm,
    session_feature_toggle_form: SessionFeatureToggleForm,
    weekly_kpi_is_showing: boolean(),
    cases_page: CasesPage,
    bearer_token_page: CreateServiceBearerTokenForm,
    chase_mode_form: CaseChaseModeForm,
    create_staff_user_page: CreateStaffUserForm,
    change_staff_user_password_page: ChangeStaffUserPasswordForm,
    crm_proof_of_funds_documents: GetProofOfFundsDocumentsFormIO,
});

export type TState = TTypeOfCodec<TStateCodec>;

export type TStateLens = TCodecLens<TStateCodec, TStateCodec>;

export const stateLens: TStateLens = createNewDefaultLens(state);